export const MINIMIZE_TOTAL_RISK_GOAL = "minimize-total-risk" as const

export const SETUP_GOALS = {
  MINIMIZE_TOTAL_RISK: MINIMIZE_TOTAL_RISK_GOAL,
} as const

export type SetupGoal = (typeof SETUP_GOALS)[keyof typeof SETUP_GOALS]
